/* tslint:disable */
/* eslint-disable */
/**
 * Fila12 API
 * Through this API you can access .
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AccessLogListDto,
    AccessLogListDtoFromJSON,
    AccessLogListDtoFromJSONTyped,
    AccessLogListDtoToJSON,
    CustomError,
    CustomErrorFromJSON,
    CustomErrorFromJSONTyped,
    CustomErrorToJSON,
} from './';

/**
 * The response with a list of objects of type "T".
 * @export
 * @interface AccessLogListDtoResponseListViewModel
 */
export interface AccessLogListDtoResponseListViewModel {
    /**
     * Gets the list of errors.
     * @type {Array<CustomError>}
     * @memberof AccessLogListDtoResponseListViewModel
     */
    readonly errors?: Array<CustomError> | null;
    /**
     * Gets or sets the list of objects.
     * @type {Array<AccessLogListDto>}
     * @memberof AccessLogListDtoResponseListViewModel
     */
    data?: Array<AccessLogListDto> | null;
}

export function AccessLogListDtoResponseListViewModelFromJSON(json: any): AccessLogListDtoResponseListViewModel {
    return AccessLogListDtoResponseListViewModelFromJSONTyped(json, false);
}

export function AccessLogListDtoResponseListViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessLogListDtoResponseListViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'errors': !exists(json, 'errors') ? undefined : (json['errors'] === null ? null : (json['errors'] as Array<any>).map(CustomErrorFromJSON)),
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(AccessLogListDtoFromJSON)),
    };
}

export function AccessLogListDtoResponseListViewModelToJSON(value?: AccessLogListDtoResponseListViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(AccessLogListDtoToJSON)),
    };
}


